export default "__VITE_ASSET__BZnVQAq8__"